import { useMutation, useQueryClient } from '@tanstack/react-query';
import { showSnackbar } from '../../../api/snackbarSlice';
import { useDispatch } from 'react-redux';
import { apiClient } from '../../../utils/axios';
import { isString } from 'lodash';
import { useState } from 'react';
import { AxiosError } from 'axios';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';

const editDraftProformaInvoice = async ({ payload, invoiceId }) => {
  const response = await apiClient.put(`/proforma-invoices/${invoiceId}`, payload);
  return response.data;
};

export const useEditDraftProformaInvoiceHandler = ({ onSuccess }) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const [error, setError] = useState(null);
  const { snackbarMessages } = useTranslatedMessages();
  const piSnacks = snackbarMessages?.proforma_invoices ?? {};

  const mutation = useMutation({
    mutationFn: editDraftProformaInvoice,
    onSuccess: (data, variables, context) => {
      dispatch(
        showSnackbar({ message: piSnacks?.draft_saved_success ?? 'Draft proforma invoice saved successfully.' }),
      );
      queryClient.invalidateQueries({ queryKey: ['proforma-invoices'] });
      onSuccess && onSuccess(variables);
    },
    onError: (error) => {
      if (error instanceof AxiosError) {
        if (error.response.status === 400) {
          setError(error.response.data.errors);
          return;
        }
        dispatch(showSnackbar({ message: error.response.data.message, severity: 'error' }));
      } else {
        dispatch(
          showSnackbar({
            message: isString(error.message) ? error.message : JSON.stringify(error.message),
            severity: 'error',
          }),
        );
      }
    },
  });

  const onSubmit = async (payload, invoiceId) => {
    mutation.mutate({ payload, invoiceId });
  };

  return {
    data: mutation.data,
    isError: mutation.isError,
    error: error,
    isPending: mutation.isPending,
    isSuccess: mutation.isSuccess,
    onSubmit: onSubmit,
  };
};
